import React, { Component } from "react";
import { Link } from "react-router-dom";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Nav, Navbar, Button, NavDropdown } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUserEdit,
  faUserFriends,
  faQuestionCircle,
  faCommentAlt,
  faChartBar,
  faSignOutAlt,
  faDollarSign,
} from "@fortawesome/free-solid-svg-icons";
import _ from "lodash";
import moment from "moment";
import Avatar from "react-avatar";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { logout, updateTenant, changeUserAttribute } from "../actions/auth";
import { getDeletedItems, getUpdatedItems } from "../actions/items";
import { getUpdatedActivities, digestNotificationTest } from "../actions/activity";
import { createNewCollection, getUserSiteContent } from "../actions/settings";
import APIUrls from "../constants/ApiUrls";
import AddContentButton from "./AddContentButton";
import imgCamelLogo from "../assets/images/main-logo-white.svg";
import iconCollectionSelected from "../assets/images/icon-collection-solid-red.svg";
import CreateCollectionForm from "./dashboard/CreateCollectionForm";
import TryNewExperienceModal from "./dashboard/TryNewExperienceModal";
import { addEventNameToEndpoint } from "../utils/common";
import { USER_SETTINGS } from "../constants/UserSettings";
import "./Navbar.scss";

const ReactSwal = withReactContent(Swal);

class MainNavbar extends Component {
  constructor(props) {
    super(props);

    this.socket = null;

    this.state = {
      setupEnabled: false,
      visibles: {
        isAddContent: true,
        isCreateCollection: false,
        isEnvironment: true,
        isLogo: true,
        isGetChrome: true,
        isMenu: true,
      },
    };

    this.timeInterval = null;
    this.isSocketConnected = false;

    window.addEventListener("notificationclick", (event) => {
      if (!event.action) {
        // Was a normal notification click
        // console.log({notification: event.notification, info: "clicked"});
        return;
      }

      switch (event.action) {
        case "view-action":
          // console.log('Viewed Item action');
          break;
        default:
          // console.log(`Unknown action clicked: '${event.action}'`);
          break;
      }
    });
  }

  getSnapshotBeforeUpdate(prevProps, prevState) {
    if (!_.isEqual(this.props, prevProps)) {
      this.updateVisibles(this.props);
    }

    return null;
  }

  async componentDidMount() {
    // From WillMount
    this.updateVisibles(this.props);
    //////

    this.setState({ setupEnabled: this.isSetupEnabled() });

    if (process.env.REACT_APP_ENVIRONMENT !== "local") {
      this.setupSocket();
    }
  }

  /**
   * Determine if the setup state is enabled
   * -> current we do this based on date of user createdAt and they are an admin
   */
  isSetupEnabled = () => {
    const isAdmin =
      _.get(
        this.props,
        "cognitoUser.attributes['custom:role']",
        _.get(this.props, "cognitoUser.challengeParam.userAttributes['custom:role']")
      ) === "admin";
    const createdAt = _.get(this.props, "userInfo.createdAt", new Date().toISOString());
    const pastDays = moment().diff(moment.parseZone(createdAt), "days");

    // check localstorage for "email" key
    // Added for rc/2024-q2-v2-upgrade-01
    let email = localStorage.getItem("email");
    if (!email) {
      email = _.get(this.props, "cognitoUser.attributes.email", null);
      if (email) {
        localStorage.setItem("email", email);
      }
    }
    return isAdmin && pastDays < 14;
  };

  onAddCollection = (params) => {
    addEventNameToEndpoint(this.props.Analytics, "admin-create-new-collection");
    this.props.createNewCollection(params);
  };

  componentDidUpdate(prevProps, prevState, snapshot) {}

  onUpdateUserNewExperienceFlag = () => {
    const currentFlags = _.get(this.props, "userInfo.flags", {});
    this.props.changeUserAttribute({ name: "flags", value: { ...currentFlags, newUiTransitionConfirmed: true } });
    window.location.href = `/v2/home`;
  };

  onClickNewExperienceButton = () => {
    const currentFlags = _.get(this.props, "userInfo.flags", {});

    if (currentFlags.newUiTransitionConfirmed) {
      window.location.href = `/v2/home`;
    } else {
      ReactSwal.fire({
        allowOutsideClick: true,
        allowEscapeKey: true,
        allowEnterKey: false,
        showCancelButton: false,
        width: "70vw",
        showConfirmButton: false,
        html: (
          <TryNewExperienceModal
            onClose={ReactSwal.clickConfirm}
            onAddCollection={this.onAddCollection}
            settings={this.props.settings}
            onUpdateUserNewExperienceFlag={this.onUpdateUserNewExperienceFlag}
          />
        ),
      });
    }
  };

  onClickCreateCollection = () => {
    ReactSwal.fire({
      allowOutsideClick: true,
      allowEscapeKey: true,
      allowEnterKey: false,
      showCancelButton: false,
      showConfirmButton: false,
      html: (
        <CreateCollectionForm
          onClose={ReactSwal.clickConfirm}
          onAddCollection={this.onAddCollection}
          settings={this.props.settings}
        />
      ),
    }).then((result) => {
      if (result.value) {
      }
    });
  };

  updateVisibles = (props) => {
    let { visibles } = this.state;
    const isAdmin =
      _.get(
        props,
        "cognitoUser.attributes['custom:role']",
        _.get(props, "cognitoUser.challengeParam.userAttributes['custom:role']")
      ) === "admin";
    const { pathname } = props;

    switch (pathname) {
      case "/":
        visibles.isCreateCollection = true;
        visibles.isAddContent = true;
        visibles.isGetChrome = true;
        break;
      case "/dashboard":
        visibles.isCreateCollection = true;
        visibles.isAddContent = true;
        visibles.isGetChrome = true;
        break;
      case "/paywall":
        visibles.isAddContent = false;
        visibles.isGetChrome = false;
        break;
      default:
        visibles = {
          isAddContent: true,
          isCreateCollection: false,
          isEnvironment: true,
          isLogo: true,
          isGetChrome: true,
          isMenu: true,
        };
        break;
    }

    if (!isAdmin) {
      visibles.isAddContent = false;
    }

    this.setState({ visibles });
  };

  setupSocket = async () => {
    let tokens = null;
    if (this.props.isAuthenticated && this.props.Auth) {
      try {
        tokens = await this.props.Auth.currentSession();
      } catch (error) {
        return;
      }

      this.socket = new WebSocket(
        `${APIUrls.socket}?authorization=${_.get(tokens, "accessToken.jwtToken", "")}&identity=${_.get(
          tokens,
          "idToken.jwtToken",
          ""
        )}`
      );

      this.socket.onopen = () => {
        console.log("Connected to server correctly.");
        this.isSocketConnected = true;
        clearInterval(this.timeInterval);
        this.timeInterval = null;
      };

      this.socket.onmessage = async (message) => {
        const data = JSON.parse(message.data);
        const { action } = data;

        switch (action) {
          case "items-update": {
            const { updatedItems } = data;
            // console.log({ action: "items-update", updatedItems });
            this.props.getUpdatedItems(updatedItems);

            if (updatedItems[0].collectionId) {
              this.props.getUserSiteContent();
            }

            break;
          }
          case "activity-update": {
            const { updatedItems } = data;
            // console.log('activity updated: ', updatedItems);
            this.props.getUpdatedActivities(updatedItems);
            break;
          }
          case "items-delete": {
            const { updatedItems } = data;
            this.props.getDeletedItems(updatedItems);
            break;
          }
          case "tenant-update": {
            const { updatedItems } = data;
            const tenantData = updatedItems[0];
            this.props.updateTenant(tenantData);

            if (tenantData.accountStatus.status !== "active" && tenantData.accountStatus.status !== "trialing") {
              this.props.history.push("/paywall");
            }
            break;
          }
          // Add new handlers for collection updates and item addition
          case "user-collections-update": {
            const { updatedItems } = data;
            // Refresh the collections in the redux store
            this.props.getUserSiteContent();
            break;
          }
          case "items-add": {
            const { updatedItems } = data;
            // Get updated items when new items are added
            this.props.getUpdatedItems(updatedItems);

            // If an item has been added to a collection, refresh collections
            if (updatedItems.some(item => item.collectionId)) {
              this.props.getUserSiteContent();
            }
            break;
          }
          case "share-view": {
            const { message: messageBody, title, createdBy } = data;

            if (
              _.get(this.props.userInfo, USER_SETTINGS.APP_OPTIONS.PUSH_ENABLED, true) &&
              createdBy === _.get(this.props.userInfo, "userId", null)
            ) {
              if (!("Notification" in window)) {
                console.log("This browser does not support notifications.");
              } else {
                if (Notification.permission === "granted") {
                  const notification = new Notification(title, {
                    body: messageBody,
                    badge: "https://static.contentcamel.io/badge-camel-128x128.png",
                    icon: "https://static.contentcamel.io/badge-camel-128x128.png",
                    image: "https://static.contentcamel.io/icon-camel-256x256.png",
                    // actions: [
                    //   {
                    //     action: 'view-action',
                    //     title: 'View'
                    //   },
                    // ]
                  });
                }
              }
            }

            break;
          }
          case "ping": {
            this.socket.send(JSON.stringify({ action: "pong" }));
            break;
          }
          default:
            break;
        }
      };

      this.socket.onclose = () => {
        console.log("Disconnected from server, Please check your network connection and reload the browser.");
        this.isSocketConnected = false;
        // this.timeInterval = setInterval(() => {
        //   if (!this.isSocketConnected) {
        //     this.setupSocket();
        //   }
        // }, 1000);
        setTimeout(() => {
          if (!this.isSocketConnected) {
            this.setupSocket();
          }
        }, 1000);
      };

      this.socket.onerror = (evt) => {
        console.log("Web Socket error: ", evt);
      };
    }
  };

  componentWillUnmount() {
    if (this.socket) {
      this.socket.close();
      clearInterval(this.timeInterval);
      this.timeInterval = null;
    }
  }

  handleLogout = async () => {
    await this.props.Auth.signOut();
    this.props.logout();

    setTimeout(() => {
      this.props.history.push("/bye");
    });
  };

  render() {
    const { user } = this.props;
    const { visibles } = this.state;
    const environment =
      process.env.REACT_APP_ENVIRONMENT === "production" ? "" : `Environment: ${process.env.REACT_APP_ENVIRONMENT}`;
    const isAdmin =
      _.get(
        this.props,
        "cognitoUser.attributes['custom:role']",
        _.get(this.props, "cognitoUser.challengeParam.userAttributes['custom:role']")
      ) === "admin";
    const userName = _.get(
      this.props,
      "cognitoUser.attributes[name]",
      _.get(this.props, "cognitoUser.challengeParam.userAttributes[name]")
    );
    const avatarImage = _.get(this.props, "cognitoUser.attributes['custom:avatar_medium']", null);

    return (
      <Navbar
        expand="lg"
        className={`main-navbar ${this.props.className}`}
        draggable="false"
        onDragStart={(e) => e.stopPropagation()}
      >
        {visibles.isLogo && (
          <Navbar.Brand>
            <Link to="/">
              <img src={imgCamelLogo} alt="CC logo" draggable="false" onDragStart={(e) => e.stopPropagation()} />
            </Link>
          </Navbar.Brand>
        )}
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="action-container">
            <div className="d-flex action-buttons">
              {(visibles.isAddContent || this.props.collectionState === "collectionEditing") && (
                <AddContentButton
                  onClick={(file) => this.props.openUploadModal(file, this.props.history.location.pathname)}
                  collectionState={this.props.collectionState}
                  collectionEvent={this.props.collectionEvent}
                  isAdmin={isAdmin}
                  user={this.props.userInfo}
                />
              )}
              {visibles.isCreateCollection && this.props.collectionState !== "collectionEditing" && (
                <div className="create-collection-button ml-2" onClick={this.onClickCreateCollection}>
                  <div className="collection-icon">
                    <img src={iconCollectionSelected} alt="collection selected" />
                  </div>
                  <span>Create new collection</span>
                </div>
              )}

              {isAdmin && (
                <div
                  className=" ml-2 cursor-pointer rounded py-1 px-2"
                  style={{ backgroundColor: "#039FAB" }}
                  onClick={this.onClickNewExperienceButton}
                >
                  <span className="m-0 p-1 text-white">Try the New Experience 🎉</span>
                </div>
              )}
            </div>
            {visibles.isEnvironment && <span>{environment}</span>}
            {visibles.isGetChrome && (
              <Button className="btn-cta">
                {this.state.setupEnabled ? (
                  <a onClick={() => this.props.history.push("/onbboarding-checklist")}>Complete Setup</a>
                ) : (
                  <a
                    href={process.env.REACT_APP_EXTENSION_INSTALL_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-cc-analytics-on="click"
                    id="btnExtensionSetup"
                    data-cc-analytics-name="user-extension-ctaClick"
                    onClick={() => addEventNameToEndpoint(this.props.Analytics, "user-extension-ctaClick")}
                    data-cc-analytics-attrs={`userId:${_.get(this.props, "cognitoUser.username", "")}`}
                  >
                    Get Extension
                  </a>
                )}
              </Button>
            )}
          </Nav>
          {visibles.isMenu && (
            <Nav className="user-menu">
              <NavDropdown id="dropdown-basic-button" title={user ? `${userName} ${isAdmin ? "| Admin" : ""}` : ""}>
                <NavDropdown.Item onClick={() => this.props.history.push("/settings")}>
                  <FontAwesomeIcon icon={faUserEdit} className="mr-2" />
                  User Settings
                </NavDropdown.Item>
                <NavDropdown.Item onClick={() => this.props.history.push("/team-settings")}>
                  <FontAwesomeIcon icon={faUserFriends} className="mr-2" />
                  Account Settings
                </NavDropdown.Item>
                <NavDropdown.Item onClick={() => this.props.history.push("/analytics")}>
                  <FontAwesomeIcon icon={faChartBar} className="mr-2" />
                  Analytics
                </NavDropdown.Item>
                {isAdmin && (
                  <NavDropdown.Item onClick={() => this.props.history.push("/wishlist")}>
                    <FontAwesomeIcon icon={faCommentAlt} className="mr-2" />
                    Wishlist
                  </NavDropdown.Item>
                )}
                {isAdmin && process.env.REACT_APP_FLAG_BILLING === "true" && (
                  <NavDropdown.Item onClick={() => this.props.history.push("/billing")}>
                    <FontAwesomeIcon icon={faDollarSign} className="mr-2" />
                    Billing
                  </NavDropdown.Item>
                )}
                <NavDropdown.Item onClick={() => window.open("https://learn.contentcamel.io", "_blank")}>
                  <FontAwesomeIcon icon={faQuestionCircle} className="mr-2" />
                  Support
                </NavDropdown.Item>
                {/* <NavDropdown.Item onClick={() => this.props.digestNotificationTest()}>
                  <FontAwesomeIcon icon={faQuestionCircle} className="mr-2" />
                  Digest test
                </NavDropdown.Item> */}
                <NavDropdown.Item onClick={this.handleLogout}>
                  <FontAwesomeIcon icon={faSignOutAlt} className="mr-2" />
                  Logout
                </NavDropdown.Item>
              </NavDropdown>
              {/* {avatarImage ? <img src={avatarImage} width="36px" height="36px" style={{ borderRadius: "50%" }} /> */}
              <Avatar name={userName} size={36} round={true} color="white" fgColor="pink" src={avatarImage} />
              {/* } */}
            </Nav>
          )}
        </Navbar.Collapse>
      </Navbar>
    );
  }
}

const mapStateToProps = (state) => ({
  cognitoUser: state.auth.cognitoUser,
  isAuthenticated: state.auth.isAuthenticated,
  Auth: state.auth.Auth,
  Analytics: state.auth.Analytics,
  userInfo: state.settings.userInfo,
  settings: state.settings,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getUpdatedItems,
      getDeletedItems,
      getUpdatedActivities,
      digestNotificationTest,
      createNewCollection,
      logout,
      updateTenant,
      getUserSiteContent,
      changeUserAttribute,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(MainNavbar);
